<template>
  <div class="transparent-tab">
    <div class="transparent_btn" v-if="visible">
      <a-radio-group v-model="activeKey" button-style="solid" @change="handleChange">
        <a-radio-button value="1">{{ $t('概览') }}</a-radio-button>
        <a-radio-button value="2">{{ $t('压力') }}</a-radio-button>
        <a-radio-button value="3">{{ $t('流量') }}</a-radio-button>
        <a-radio-button value="4">{{ $t('流速') }}</a-radio-button>
      </a-radio-group>
    </div>
  </div>
</template>
      
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JInput from '../../../../components/jeecg/JInput.vue'
export default {
  name: 'modal',
  components: {
    JInput,
  },
  data() {
    return {
      title: this.$t('组件'),
      width: 800,
      visible: true,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {},
      activeKey: '1',
    }
  },
  methods: {
    init() {
      this.visible = !this.visible;
    },
    handleChange(e) {
      this.activeKey = e.target.value
      let params = {
        activeKey: this.activeKey
      }
      if(this.activeKey==1){
        params.type = 'CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL'
      }else if(this.activeKey==2){
        params.type = 'CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE'
      }else if(this.activeKey==3){
        params.type = 'LIU_LIANG'
      }else if(this.activeKey==4){
        params.type = 'LIU_SU'
      }
      this.$emit('change', params);
    },
  },
}
</script>
  <style lang="less" scoped>
.transparent-tab {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: rgba(70, 76, 92, 0.9);
  border-color: rgba(70, 76, 92, 0.9);
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: rgba(70, 76, 92, 0.9);
}
.ant-radio-button-wrapper {
  background: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0 25px;
}
</style>